/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ReverseMedicationAliases {
  AUTOCOMPLETE_REVERSE_MEDICATION_REASONS = 'autocomplete-reverse-medication-reasons',
  FETCH_REVERSE_MEDICATION_REASONS = 'fetch-reverse-medication-reasons',
  FIELD_REVERSE_MEDICATION_JUSTIFICATION = 'field-reverse-medication-justification',
  FIELD_REVERSE_MEDICATION_REASONS = 'field-reverse-medication-reasons',
  FORM_REVERSE_MEDICATION = 'form-reverse-medication',
  FRAGMENT_REFERENCE_INFORMATION = 'fragment-reference-information',
  LAYOUT_REVERSE_MEDICATION = 'layout-reverse-medication',
  MAPPER_REVERSE_MEDICATION_REASONS = 'mapper-reverse-medication-reasons',
  PANEL_CONTENT = 'panel-content',
  PANEL_HEADER = 'panel-header',
  TEXT_REVERSE_MEDICATION_JUSTIFICATION = 'text-reverse-medication-justification',
  TEXT_REVERSE_MEDICATION_REASONS = 'text-reverse-medication-reasons',
}
export { ReverseMedicationAliases };
